import { DateTime } from 'luxon';
import { v4 as uuidv4 } from 'uuid';

import { accountsSelectors } from 'app-components/flux/accounts';
import { categoriesSelectors } from 'app-components/flux/categories';
import store from 'app-components/utils/redux-store';

const potentialRecurrings = () => {
  const dateNow = DateTime.local();
  const dateNowIso = dateNow.toISODate();
  const account = accountsSelectors.getBankAccounts(store.getState())?.first();
  const personalIncomeCategory = categoriesSelectors.getPersonalIncomeCategory(store.getState());
  const federalEstimatedTaxPaymentCategory = categoriesSelectors.getFederalEstimatedTaxPaymentCategory(
    store.getState(),
  );
  return [
    {
      clientId: uuidv4(),
      isUserVerified: false,
      type: 'BILL',
      source: 'BILL_SCOUT_AGGREGATION',
      dueOn: dateNowIso,
      recurrence: {
        interval: 1,
        frequency: 'MONTHLY',
        byMonthDay: [dateNow.day],
      },
      transaction: {
        type: 'CASH_FLOW',
        accountId: account?.id || '',
        payee: 'The Music School',
        coa: {
          type: 'CATEGORY',
          id: federalEstimatedTaxPaymentCategory?.id || '',
        },
        amount: -33.62,
        isBill: true,
      },
    },
    // {
    //   clientId: uuidv4(),
    //   isUserVerified: false,
    //   type: 'BILL',
    //   source: 'BILL_SCOUT_AGGREGATION',
    //   dueOn: dateNowIso,
    //   recurrence: {
    //     interval: 1,
    //     frequency: 'MONTHLY',
    //     byMonthDay: [dateNow.day],
    //   },
    //   transaction: {
    //     type: 'CASH_FLOW',
    //     accountId: account?.id || '',
    //     payee: 'AT&T',
    //     coa: {
    //       type: 'CATEGORY',
    //       id: federalEstimatedTaxPaymentCategory?.id || '',
    //     },
    //     amount: -64.99,
    //     isBill: true,
    //   },
    // },
    {
      clientId: uuidv4(),
      isUserVerified: false,
      type: 'INCOME',
      source: 'BILL_SCOUT_AGGREGATION',
      dueOn: dateNowIso,
      recurrence: {
        interval: 1,
        frequency: 'MONTHLY',
        byMonthDay: [dateNow.day],
      },
      transaction: {
        type: 'CASH_FLOW',
        accountId: account?.id || '',
        payee: 'My Paycheck',
        coa: {
          type: 'CATEGORY',
          id: personalIncomeCategory?.id || '',
        },
        amount: 1000.0,
        isBill: false,
      },
    },
    // {
    //   clientId: uuidv4(),
    //   isUserVerified: false,
    //   type: 'INCOME',
    //   source: 'BILL_SCOUT_AGGREGATION',
    //   dueOn: dateNowIso,
    //   recurrence: {
    //     interval: 1,
    //     frequency: 'MONTHLY',
    //     byMonthDay: [dateNow.day],
    //   },
    //   transaction: {
    //     type: 'CASH_FLOW',
    //     accountId: account?.id || '',
    //     payee: 'Dividends',
    //     coa: {
    //       type: 'CATEGORY',
    //       id: personalIncomeCategory?.id || '',
    //     },
    //     amount: 1234.56,
    //     isBill: false,
    //   },
    // },
  ];
};

export default potentialRecurrings;
